import type { RequestOptions } from '@mp/http-axios'
import type { AxiosRequestConfig } from 'axios'

import { createAxios } from './index'

// 这是一个特殊的服务，是网关直接暴露的接口，没有 swagger 文档，所以所有代码是手写的，不是自动生成

// #region gateway request start
export const defHttp = createAxios({
  requestOptions: {
    // 接口地址
    apiUrl: window.location.origin,
    // 接口拼接地址
    urlPrefix: '/mchgateway',
  },
})

export function request<T>(url: string, options: AxiosRequestConfig & { customOptions?: RequestOptions }): Promise<T> {
  const { customOptions } = options || {}
  return defHttp.request({ ...options, url }, customOptions)
}
// #endregion gateway request end
